<template>
  <div
    class="bg fill-height"
  >
    <v-container class="fill-height">
      <v-row
        align="center"
        justify="center"
        class="fill-height"
      >
        <v-col>
          <v-img
            :src="require('@/assets/logo/grafismo-logo-mappa.png')"
            contain
            max-width="500px"
          >
          </v-img>
        </v-col>
        <v-col class="text-center">
          <p class="display-4 font-weight-regular">500</p>
          <p class="display-1 font-weight-regular">Desculpe!</p>
          <p class="display-1 font-weight-regular">Algum erro inesperado aconteceu</p>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
  export default {
    name: "InternalServerError",
  }
</script>

<style scoped lang="scss">
  .bg {
    background: url("../../assets/general/bg-neutral.jpg");
    background-size: cover;
  }
</style>
